import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Globe, Linkedin, PlayCircle, Whatsapp } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import SubDomainRouter from "../../components/subDomainRouter/subDomainRouter";

const ItemInfo = ({ itemData }) => {
  const freelancerAlias = SubDomainRouter("freelancerAlias");

  return (
    <Card className="border-top-0 rounded-top-0">
      <Card.Body>
        <h5 className="theme-text-2 mt-2 pb-lg-3 pb-2 text-capitalize">
          {freelancerAlias ? freelancerAlias : "demo"} Details:
        </h5>
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Full Name
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 text-capitalize">
              {itemData?.first_name + " " + itemData?.last_name ||
                "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              job title
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 text-capitalize">
              {itemData?.job_title || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              email
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0">
              {itemData?.email || "Not available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">BIO</Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 text-capitalize">
              {itemData?.bio || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              industry
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 text-capitalize">
              {itemData?.industry || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Address
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0">
              {itemData?.city || "Not Available"},&nbsp;
              {itemData?.country || "Not Available"}
            </Card.Text>
          </Col>
        </Row>

        {itemData?.video_url && (
          <>
            <hr />
            <Row>
              <Col md={4}>
                <Card.Text className="mb-0 fw-bold text-capitalize">
                  Intro Video
                </Card.Text>
              </Col>
              <Col md={8}>
                <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
                  <Link
                    to={itemData?.video_url}
                    target="_blank"
                    className="btn-link theme-text-2 btn d-flex align-items-center gap-1 text-decoration-none p-0"
                  >
                    <PlayCircle /> Watch Video
                  </Link>
                </Card.Text>
              </Col>
            </Row>
          </>
        )}

        {itemData?.whatsapp || itemData?.linkedin || itemData?.website ? (
          <>
            <hr />
            <Row>
              <Col md={4}>
                <Card.Text className="mb-0 fw-bold text-capitalize">
                  Social Links
                </Card.Text>
              </Col>
              <Col
                md={8}
                className="social d-flex gap-md-3 gap-2 flex-wrap align-items-center"
              >
                {itemData?.linkedin ? (
                  <a
                    target="_blank"
                    href={`${itemData?.linkedin}`}
                    rel="noreferrer"
                  >
                    <Linkedin />
                  </a>
                ) : null}
                {itemData?.whatsapp ? (
                  <a href={`tel:${itemData?.whatsapp}`} rel="noreferrer">
                    <Whatsapp />
                  </a>
                ) : null}
                {itemData?.website ? (
                  <a
                    target="_blank"
                    href={`${itemData?.website}`}
                    rel="noreferrer"
                  >
                    <Globe />
                  </a>
                ) : null}
              </Col>
            </Row>
          </>
        ) : null}
      </Card.Body>

      <Card.Body>
        <h5 className="theme-text-2 mt-2 pb-lg-3 pb-2 text-capitalize">
          Freelancing Profile Details
        </h5>
        <hr />

        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Primary Skill Set
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.primary_skillset || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Secondary Skill Set
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.secondary_skillset || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Total years of Work Experience
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.experience || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Academic Qualification
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.qualification || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Looking for
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.aim || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Current Salary
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.current_salary || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Salary
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.expected_salary || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Hourly Rate(Hr)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.hourly_rate || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Daily Rate(8Hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.daily_rate || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Weekly Rate (40hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.weekly_rate || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Monthly Rate (160hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.monthly_rate || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Daily Availability(Hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.daily_availability || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Weekly Availability (Hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.weekly_availability || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Expected Monthly Availability (hrs)
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.monthly_availability || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={4}>
            <Card.Text className="mb-0 fw-bold text-capitalize">
              Interest in Equity based compensation?*
            </Card.Text>
          </Col>
          <Col md={8}>
            <Card.Text className="text-muted mb-0 d-flex align-items-center gap-2">
              {itemData?.interest || "Not Available"}
            </Card.Text>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ItemInfo;
